module.exports = __webpack_public_path__ + "static/media/tags.b5bc49f0.svg";